<template>
    <div class="action-menu">
        <button class="action-menu__edit" :class="{'is-active' : isActive}" @click="isActive = !isActive"><svg class="icon icon-Edit"><use xlink:href="#icon-Edit"></use></svg></button>

        <div class="action-menu__buttons" :class="{'is-active' : isActive}">
            <button @click="swipeSingleCard(driverId)" class="button is-black"><svg class="icon icon-Sort"><use xlink:href="#icon-Sort"></use></svg> Re-swipe VD</button>
            <button class="button is-black" @click="removeFromFeed"><svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg> Remove from feed</button>
        </div>
    </div>
</template>

<script>
    import router from '../router.js';
    import Icon from './Icon';
    import EventBus from '../eventbus.js';

    export default {
        props: [
            'driverId'
        ],
        data : function() {
            return {
                isActive: false
            }
        },
        watch: {
            isActive(value) {
                this.$emit('toggle', value);
            }
        },
        created() {
        },
        computed: {
        },
        mounted() {
        },
        methods : {
            removeFromFeed() {
                this.$emit('removeFromFeed', true);
            },
            swipeSingleCard(driverId) {
                // to="/custom-dashboard/2"
                this.$store.commit('setReSwipeDriver', driverId);
                router.push('/custom-dashboard/2');
            }
        },
        components : {
        }
    }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ActionMenu.vue